let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("4cA2p"), load("ctZCD"), load("19XET"), load("kUAIU"), load("fRrg0")]).then(() => parcelRequire('7aApD'));